import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { joinHomeByToken } from '../utils/api';

const JoinHome = ({ onJoined }) => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('joining'); // joining | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    joinHomeByToken(token)
      .then(({ data }) => {
        setStatus('success');
        setMessage(`You've joined "${data.name}"!`);
        setTimeout(() => {
          onJoined();
          navigate('/');
        }, 1500);
      })
      .catch((err) => {
        const msg = err.response?.data?.message || 'Invalid or expired invitation link.';
        setStatus('error');
        setMessage(msg);
      });
  }, []); // intentionally run once on mount

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', padding: '2rem' }}>
      <div style={{ maxWidth: 420, width: '100%', textAlign: 'center' }}>
        {status === 'joining' && (
          <>
            <div className="loading-spinner" style={{ marginBottom: '1rem' }} />
            <p>Joining home…</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>✓</div>
            <p style={{ color: 'var(--success)' }}>{message}</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>⚠</div>
            <p style={{ color: 'var(--danger)', marginBottom: '1.5rem' }}>{message}</p>
            <button className="btn btn-secondary" onClick={() => navigate('/')}>Go Home</button>
          </>
        )}
      </div>
    </div>
  );
};

export default JoinHome;
